import { render, staticRenderFns } from "./ConsultantRoute.vue?vue&type=template&id=d27245da"
import script from "./ConsultantRoute.vue?vue&type=script&lang=js"
export * from "./ConsultantRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports